import { PickedQuestion, FlattenedPickedQuestion } from "api/sms-api";

/**
 * アイテムのすべての子孫のIDを再帰的に取得
 * @param item - 対象のアイテム
 * @returns すべての子孫のIDの配列
 */
export const getAllDescendantIds = (
  item: PickedQuestion | FlattenedPickedQuestion
): string[] => {
  const ids: string[] = [];
  item.children.forEach((child) => {
    if (child.id) {
      ids.push(child.id);
    }
    ids.push(...getAllDescendantIds(child));
  });
  return ids;
};

/**
 * アイテムのすべての子孫のselectIdを再帰的に取得
 * @param item - 対象のアイテム
 * @returns すべての子孫のselectIdの配列
 */
export const getAllDescendantSelectIds = (
  item: PickedQuestion | FlattenedPickedQuestion
): string[] => {
  const selectIds: string[] = [];
  item.children.forEach((child) => {
    if (child.selectId) {
      selectIds.push(child.selectId);
    }
    selectIds.push(...getAllDescendantSelectIds(child));
  });
  return selectIds;
};
